import { createFileRoute, redirect } from '@tanstack/react-router';

import { addTrackCrumb } from '../../error/tracking';
import { tanstackLocationWithUtm } from '../../shared/utm';

// import { signOut } from '../../sdk/authorization';

export const Route = createFileRoute('/auth/')({
  beforeLoad: function () {
    addTrackCrumb({
      category: 'route',
      message: '/auth/',
      level: 'info',
    });

    // TODO: do we still need the sign out? maybe we take the error and redirect
    // signOut().catch(function (_err) {
    //   // NOTE: this is just a safe case, we can ignore the error
    // });
  },
  loader: function (_data) {
    if (window.location.href.indexOf('/auth/signup') !== -1) {
      // do nothing if already on signup this can happen
      // for example when coming from outside cta
      return null;
    }

    const searchParams = new URLSearchParams(window.location.search);
    const status = searchParams.get('status');
    const endpoint = status !== 'sign_up' ? '/auth/signin' : '/auth/signup';

    const nextQuery = new URLSearchParams();
    if (status != null && status.length > 0) {
      nextQuery.set('status', status);
    }
    const qs = nextQuery.toString();
    const pathWithStatus = qs.length > 0 ? `${endpoint}?${qs}` : endpoint;

    addTrackCrumb({
      category: 'auth',
      message: `redirecting to ${endpoint}`,
      level: 'info',
    });

    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect(tanstackLocationWithUtm(pathWithStatus));
  },

  component: () => null,
});
